import { EVENT_TYPE } from "constants/eventType";
import { useEffect, useState } from "react";

import type { Event } from "@spwn/types/firebase/firestore";
import type { EventType } from "constants/eventType";

type UseBrandEventDisplayInput = {
  archiveEvents: Event[] | undefined;
  comingEvents: Event[] | undefined;
  vodEvents: Event[] | undefined;
  isLoading: boolean;
};

/**
 * ブランドイベント表示用のカスタムフック
 * ローディング状態とイベントデータに基づいて、表示するイベントタイプと
 * イベントリストを管理する
 */
export const useBrandEventDisplay = (input: UseBrandEventDisplayInput) => {
  const { archiveEvents, comingEvents, isLoading, vodEvents } = input;

  const [upcomingEventType, setUpcomingEventType] = useState<EventType>(
    EVENT_TYPE.EVENT
  );
  const [displayEvents, setDisplayEvents] = useState<Event[]>([]);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (comingEvents?.length) {
      setUpcomingEventType(EVENT_TYPE.UPCOMING);
      setDisplayEvents(comingEvents);
      return;
    }

    if (vodEvents?.length) {
      setUpcomingEventType(EVENT_TYPE.VOD);
      setDisplayEvents(vodEvents);
      return;
    }

    if (archiveEvents?.length) {
      setUpcomingEventType(EVENT_TYPE.ARCHIVE);
      setDisplayEvents(archiveEvents);
      return;
    }

    setUpcomingEventType(EVENT_TYPE.EVENT);
    setDisplayEvents([]);
  }, [isLoading, comingEvents, vodEvents, archiveEvents]);

  return { displayEvents, upcomingEventType };
};
